import { useRef } from "react";
import { clamp } from "@/lib/photoEdit";

const MIN = 0.1;
const POS = { tl: "-left-5 -top-5", tr: "-right-5 -top-5", bl: "-left-5 -bottom-5", br: "-right-5 -bottom-5" };

export const CropBox = ({ rect, onChange }) => {
  const ref = useRef(null);
  const drag = useRef(null);

  const move = (e) => {
    const c = drag.current;
    if (!c) return;
    const r = ref.current.parentElement.getBoundingClientRect();
    const px = clamp((e.clientX - r.left) / r.width);
    const py = clamp((e.clientY - r.top) / r.height);
    let { x, y } = rect;
    let x2 = rect.x + rect.w, y2 = rect.y + rect.h;
    if (c.includes("l")) x = Math.min(px, x2 - MIN);
    if (c.includes("r")) x2 = Math.max(px, x + MIN);
    if (c.includes("t")) y = Math.min(py, y2 - MIN);
    if (c.includes("b")) y2 = Math.max(py, y + MIN);
    onChange({ x, y, w: x2 - x, h: y2 - y });
  };

  return (
    <div ref={ref} data-testid="photo-crop-box" className="absolute border-2 border-white shadow-[0_0_0_9999px_rgba(0,0,0,0.55)]"
      style={{ left: `${rect.x * 100}%`, top: `${rect.y * 100}%`, width: `${rect.w * 100}%`, height: `${rect.h * 100}%` }}>
      <div className="pointer-events-none absolute inset-0 grid grid-cols-3 grid-rows-3">
        {Array.from({ length: 9 }).map((_, i) => <div key={i} className="border border-white/25" />)}
      </div>
      {Object.keys(POS).map((c) => (
        <div key={c} data-testid={`photo-crop-handle-${c}`}
          onPointerDown={(e) => { e.stopPropagation(); e.currentTarget.setPointerCapture(e.pointerId); drag.current = c; }}
          onPointerMove={move}
          onPointerUp={() => { drag.current = null; }}
          onPointerCancel={() => { drag.current = null; }}
          className={`absolute ${POS[c]} h-10 w-10 touch-none flex items-center justify-center`}>
          <span className="h-4 w-4 rounded-full bg-white shadow" />
        </div>
      ))}
    </div>
  );
};
